import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '../api/session';

const NAV = [
  { to: '/feed', label: 'Feed' },
  { to: '/zones', label: 'Άτλας' },
  { to: '/map', label: 'Χάρτης' },
  { to: '/analytics', label: 'Analytics' },
  { to: '/settings', label: 'Settings' },
];

export function Layout() {
  const { state, logout } = useSession();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const userName = state.status === 'authed' ? state.user.name : null;

  // The Atlas (/zones) is a full-bleed page — it manages its own canvas
  // (background + padding), so the shared max-width content frame is dropped.
  const fullBleed = pathname === '/zones';

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-2">
            <span className="text-lg font-bold text-rose-600">●</span>
            <span className="font-semibold text-slate-900">AuctionRadar</span>
          </div>
          <nav className="flex items-center gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded px-3 py-1.5 text-sm font-medium transition ${
                    isActive
                      ? 'bg-slate-900 text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            {userName && (
              <div className="ml-3 flex items-center gap-2 border-l border-slate-200 pl-3 text-xs text-slate-500">
                <span>{userName}</span>
                <button
                  onClick={handleLogout}
                  className="rounded px-2 py-1 text-xs font-medium text-slate-500 hover:bg-slate-100 hover:text-slate-900"
                >
                  Έξοδος
                </button>
              </div>
            )}
          </nav>
        </div>
      </header>
      <main className={fullBleed ? '' : 'mx-auto max-w-6xl px-6 py-6'}>
        <Outlet />
      </main>
    </div>
  );
}
